import { TQRPaperSize } from './qr-pdf.component';

const MONOCHROMATIC_SOLVEI8_LOGO_PATH = 'assets/icon/solvei8/solvei8-monochromatic.svg';

const A4_STYLE = {
  QrLogo: {
    width: 200,
    margin: 0,
  },
  solvei8LogoSrc: MONOCHROMATIC_SOLVEI8_LOGO_PATH,
  showPdfData: true,
  printStyle: {
    'div.container': {
      display: 'flex',
      'flex-flow': 'wrap',
      'row-gap': '30px',
      'column-gap': '4%',
      'margin-top': '8px',
      //Note: below are A4 dimensions that we can use for testing
      // width: '210mm',
      // height: '297mm',
      // border: '1px solid blue',
    },
    'div.container-item': {
      'flex-basis': '48%',
      'page-break-inside': 'avoid',
      'break-inside': 'avoid',
    },
    'div.qr-container': {
      width: 'unset',
      height: 'unset',
      border: '1px solid black',
      padding: '8px',
      'text-align': 'center',
    },
    'div.header': {
      padding: '16px 0 12px 0',
      display: 'flex',
      'max-height': '20%',
      'justify-content': 'space-around',
    },
    'table.data-table': {
      margin: '0 auto',
      padding: '12px 0',
    },
    td: {
      padding: '8px',
      'word-break': 'break-word',
      'text-align': 'left',
      'vertical-align': 'top',
      'font-size': 'normal',
    },
    'div.factory-logo-container': {
      'align-self': 'stretch',
      'flex-basis': 'auto',
      flex: '1',
    },
    'div.solvei8-logo-container': {
      'align-self': 'center',
      'flex-basis': '50%',
      flex: '1',
    },
    'img.factory-logo': {
      float: 'none',
      width: '100%',
      'object-fit': 'contain',
      'max-height': '100%',
    },
    'img.solvei8-logo': {
      float: 'none',
      width: '52%',
      height: 'unset',
    },
  },
};

const A4_SMALL_STYLE = {
  QrLogo: {
    width: 140,
    margin: 0,
  },
  solvei8LogoSrc: MONOCHROMATIC_SOLVEI8_LOGO_PATH,
  showPdfData: false,
  printStyle: {
    'div.container': {
      display: 'flex',
      'flex-flow': 'wrap',
      'row-gap': '20px',
      'column-gap': '4%',
      'margin-top': '8px',
      ///Note: below are A4 dimensions that we can use for testing
      // width: '210mm',
      // height: '297mm',
      // border: '1px solid blue',
    },
    'div.container-item': {
      'flex-basis': '21%',
      'page-break-inside': 'avoid',
      'break-inside': 'avoid',
    },
    'div.qr-container': {
      width: 'unset',
      height: 'unset',
      border: '1px solid black',
      padding: '12px',
      'text-align': 'center',
    },
    'div.header': {
      padding: '0 0 8px 0',
      display: 'flex',
    },
    'table.data-table': {
      margin: '0 auto',
    },
    td: {
      padding: '8px',
      'word-break': 'break-word',
      'text-align': 'center',
      'font-size': '14px',
    },
    'div.factory-logo-container': {
      'align-self': 'flex-start',
      'flex-basis': '50%',
    },
    'div.solvei8-logo-container': {
      'align-self': 'flex-start',
      'flex-basis': '50%',
    },
    'img.factory-logo': {
      float: 'left',
      width: '112%',
      'max-height': '24px',
      'object-fit': 'contain',
    },
    'img.solvei8-logo': {
      float: 'right',
      width: '66%',
      height: 'unset',
    },
  },
};

const A2_STYLES = {
  QrLogo: {
    width: 160,
    margin: 0,
  },
  solvei8LogoSrc: MONOCHROMATIC_SOLVEI8_LOGO_PATH,
  showPdfData: true,
  printStyle: {
    'div.container': {
      display: 'flex',
      'flex-flow': 'wrap',
      'row-gap': '30px',
      'column-gap': '4%',
      'margin-top': '8px',
      ///Note: below are A2 dimensions that we can use for testing
      // width: '420mm',
      // height: '594mm',
      // border: '1px solid blue',
    },
    'div.container-item': {
      'flex-basis': '21%',
      'page-break-inside': 'avoid',
      'break-inside': 'avoid',
    },
    'div.qr-container': {
      width: 'unset',
      height: 'unset',
      border: '1px solid black',
      padding: '36px 16px',
      'text-align': 'center',
    },
    'div.header': {
      padding: '0 0 16px 0',
      display: 'flex',
      'max-height': '20%',
      'justify-content': 'space-around',
    },
    'table.data-table': {
      margin: '0 auto',
      padding: '12px 0 0 0',
    },
    td: {
      padding: '8px',
      'word-break': 'break-word',
      'text-align': 'left',
      'font-size': 'normal',
    },
    'div.factory-logo-container': {
      'align-self': 'stretch',
      'flex-basis': 'auto',
      flex: '1',
    },
    'div.solvei8-logo-container': {
      'align-self': 'center',
      'flex-basis': '50%',
      flex: '1',
    },
    'img.factory-logo': {
      float: 'none',
      width: '100%',
      'max-height': '100%',
      'object-fit': 'contain',
    },
    'img.solvei8-logo': {
      float: 'none',
      width: '60%',
      height: 'unset',
    },
  },
};

const SINGLE_COLUMN_STYLES = {
  QrLogo: {
    width: 100,
    margin: 0,
  },
  solvei8LogoSrc: MONOCHROMATIC_SOLVEI8_LOGO_PATH,
  showPdfData: false,
  printStyle: {
    'div.container': {
      display: 'flex',
      'flex-flow': 'column',
      'row-gap': '20px',
      'column-gap': '0',
      'margin-top': '8px',
      //Note: below are 60mm * 60mm dimensions that we can use for testing
      // width: '60mm',
      // height: '60mm',
      // border: '1px solid blue'
    },
    'div.container-item': {
      'flex-basis': 'unset',
      'page-break-inside': 'avoid',
      'break-inside': 'avoid',
    },
    'div.qr-container': {
      width: 'unset',
      height: 'unset',
      border: '1px solid black',
      padding: '8px',
      'text-align': 'center',
    },
    'div.header': {
      padding: '0 0 8px 0',
      display: 'flex',
    },
    'table.data-table': {
      margin: '0 auto',
    },
    td: {
      padding: '4px',
      'word-break': 'break-word',
      'text-align': 'center',
      'font-size': '20px',
    },
    'div.factory-logo-container': {
      'align-self': 'flex-start',
      'flex-basis': '50%',
    },
    'div.solvei8-logo-container': {
      'align-self': 'flex-start',
      'flex-basis': '50%',
    },
    'img.factory-logo': {
      float: 'left',
      width: '100%',
      'object-fit': 'contain',
      'max-height': '150px',
    },
    'img.solvei8-logo': {
      float: 'right',
      width: '60%',
      height: 'unset',
    },
  },
};

export type TPrintStyleConfig = {
  [key in TQRPaperSize]: typeof SINGLE_COLUMN_STYLES;
};

export const PRINT_STYLES: TPrintStyleConfig = {
  A2: A2_STYLES,
  A4: A4_STYLE,
  A4_SMALL: A4_SMALL_STYLE,
  SINGLE_COLUMN: SINGLE_COLUMN_STYLES,
};
